module.exports = "/static/core/dist/TitilliumWeb-Regular.ttf";